import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/app/apps/web/src/features/auth/components/forgot-password-form.tsx");
